// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CbX0","clinicsSelect":"styles_clinicsSelect__gyTD7"};